/*
 * userProfiling Actions
 *
 * @version 1.0.0
 * @author NEOSYN\user
 * @since 18-Oct-2024
 */

import { createRequestTypes, createAction, MakeRequest } from './index'

export const actionTypes = {
  DO_GET_TAB_BAR: '@@userProfiling/get_tab_bar',
  DO_PROFILING: '@@userProfiling/profiling',
  DO_OPEN_MENU: '@@userProfiling/open_menu',
  DO_GET_NAVIGATION_PROFILE: '@@userProfiling/get_navigation_profile',
  DO_GET_NAVIGATION_MENU: '@@userProfiling/get_navigation_menu',
  DO_GET_NEW_MESSAGES: '@@userProfiling/get_new_messages',
  DO_GET_NEW_DOCUMENTS: '@@userProfiling/get_new_documents',
  DO_GET_AML_STATUS: '@@userProfiling/get_aml_status',
  DO_GET_RESULTS_GRAPH_VIEWED: '@@userProfiling/get_results_graph_viewed',
  DO_UPDATE_PHONE_FROM_SERVICES: '@@userProfiling/update_phone_from_services',
  DO_UPDATE_TUTORIAL: '@@userProfiling/update_tutorial',
  DO_GET_SERVICE_QUICK_LINKS: '@@userProfiling/get_service_quick_links',

  // @generator action:type
  ...createRequestTypes('@@userProfiling', 'GET_TAB_BAR'),
  ...createRequestTypes('@@userProfiling', 'PROFILING'),
  ...createRequestTypes('@@userProfiling', 'GET_NAVIGATION_PROFILE'),
  ...createRequestTypes('@@userProfiling', 'GET_NAVIGATION_MENU'),
  ...createRequestTypes('@@userProfiling', 'GET_NEW_MESSAGES'),
  ...createRequestTypes('@@userProfiling', 'GET_NEW_DOCUMENTS'),
  ...createRequestTypes('@@userProfiling', 'GET_AML_STATUS'),
  ...createRequestTypes('@@userProfiling', 'GET_RESULTS_GRAPH_VIEWED'),
  ...createRequestTypes('@@userProfiling', 'UPDATE_TUTORIAL'),
  ...createRequestTypes('@@userProfiling', 'GET_SERVICE_QUICK_LINKS')
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name getTabBar
 * @return {object} - The action object
 */
export const getTabBar = new MakeRequest('userProfiling', 'get_tab_bar')

/** @action request
 * * Insert a description
 * @name profiling
 * @return {object} - The action object
 */
export const profiling = new MakeRequest('userProfiling', 'profiling')
/** @action request
 * * Insert a description
 * @name getNavigationProfile
 * @return {object} - The action object
 */
export const getNavigationProfile = new MakeRequest('userProfiling', 'get_navigation_profile')
/** @action request
 * * Insert a description
 * @name getNavigationMenu

 * @return {object} - The action object
 */
export const getNavigationMenu = new MakeRequest('userProfiling', 'get_navigation_menu')
/** @action request
* * Insert a description
* @name getNewMessages
* @return {object} - The action object
*/
export const getNewMessages = new MakeRequest('userProfiling', 'get_new_messages')
/** @action request
 * * Insert a description
 * @name getNewDocuments
 * @return {object} - The action object
 */
export const getNewDocuments = new MakeRequest('userProfiling', 'get_new_documents')
/** @action request
 * * Insert a description
 * @name getAmlStatus
 * @return {object} - The action object
 */
export const getAmlStatus = new MakeRequest('userProfiling', 'get_aml_status')
/** @action request
 * * Insert a description
 * @name getResultsGraphViewed
 * @return {object} - The action object
 */
export const getResultsGraphViewed = new MakeRequest('userProfiling', 'get_results_graph_viewed')
/** @action request
 * * Insert a description
 * @name updateTutorial
 * @return {object} - The action object
 */
export const updateTutorial = new MakeRequest('userProfiling', 'update_tutorial')
/** @action request
 * * Insert a description
 * @name getServiceQuickLinks
 * @return {object} - The action object
 */
export const getServiceQuickLinks = new MakeRequest('userProfiling', 'get_service_quick_links')
// @generator action:request
/** @action
 * * Insert a description
 * @name GetTabBar
 * @return {object} - The payload object
 */
export const doGetTabBar = (payload) => createAction(actionTypes.DO_GET_TAB_BAR, { payload })
/** @action
 * * Insert a description
 * @name Profiling
 * @return {object} - The payload object
 */
export const doProfiling = (payload) => createAction(actionTypes.DO_PROFILING, { payload })
// @generator action
/** @action
 * * Insert a description
 * @name OpenMenu
 * @return {object} - The payload object
 */
export const doOpenMenu = (payload) => createAction(actionTypes.DO_OPEN_MENU, { payload })
/** @action
 * * Insert a description
 * @name doGetNavigationProfile
 * @return {object} - The payload object
 */
export const doGetNavigationProfile = () => createAction(actionTypes.DO_GET_NAVIGATION_PROFILE, {})
/** @action
 * * Insert a description
 * @name doGetNavigationMenu
 * @return {object} - The payload object
 */
export const doGetNavigationMenu = () => createAction(actionTypes.DO_GET_NAVIGATION_MENU, {})
/** @action
 * * Insert a description
 * @name doGetNewMessages
 * @return {object} - The payload object
 */
export const doGetNewMessages = () => createAction(actionTypes.DO_GET_NEW_MESSAGES, {})
/** @action
 * * Insert a description
 * @name doGetNewDocuments
 * @return {object} - The payload object
 */
export const doGetNewDocuments = (payload) => createAction(actionTypes.DO_GET_NEW_DOCUMENTS, { payload })
/** @action
 * * Insert a description
 * @name doGetAmlStatus
 * @return {object} - The payload object
 */
export const doGetAmlStatus = () => createAction(actionTypes.DO_GET_AML_STATUS, {})

/** @action
 * * Insert a description
 * @name doResultsGraphViewed
 * @return {object} - The payload object
 */
export const doGetResultsGraphViewed = () => createAction(actionTypes.DO_GET_RESULTS_GRAPH_VIEWED, {})

/** @action
 * * Insert a description
 * @name doUpdatePhoneFromServices
 * @return {object} - The payload object
 */
export const doUpdatePhoneFromServices = (payload) => createAction(actionTypes.DO_UPDATE_PHONE_FROM_SERVICES, { payload })
// @generator action

/** @action
 * * Insert a description
 * @name doUpdateTutorial
 * @return {object} - The payload object
 */
export const doUpdateTutorial = (payload) => createAction(actionTypes.DO_UPDATE_TUTORIAL, { payload })
/** @action
 * * Insert a description
 * @name doGetServiceQuickLinks
 * @return {object} - The payload object
 */
export const doGetServiceQuickLinks = () => createAction(actionTypes.DO_GET_SERVICE_QUICK_LINKS, {})
